import styled from "styled-components";

// ─── Styled Components ────────────────────────────────────────────────────────

export const TextWrapper = styled.span`
  line-height: 1.6;
`;

export const ReadMoreToggle = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin-left: 4px;
  cursor: pointer;
  color: #f15922;
  font-weight: 600;
  font-size: inherit;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid #f15922;
    outline-offset: 2px;
    border-radius: 2px;
  }
`;
